export const linkRegex = new RegExp(
  /^(https?|ftp):\/\/([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/\S*)?$/,
  'i'
)

export const labelRegex = new RegExp('^[0-9A-Za-zÀ-ÖØ-öø-ÿ ()\\-_\\[\\]\\/\\\\]{1,32}$', 'i')

export const nameRegex = new RegExp('^[0-9A-Za-zÀ-ÖØ-öø-ÿ ()\\-_\\[\\]\\/\\\\]{4,128}$', 'i')

export const emailRegex = new RegExp(/^[\w-+\\.]+@([\w-]+\.)+[\w-]{2,24}$/, 'i')
